import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import { configureAnalytics } from "./analytics/common";
import AnalyticsContext, {
    AnalyticsContextState,
} from "./contexts/analyticsContext";

import EmbedInEmailContext, {
    EmbedInEmailContextState,
} from "./contexts/embedInEmailContext";

import { getUser } from "./vimeoClient";

import { getUserIdFromUri } from "./common";

function App() {
    const [embedInEmailContextState, setEmbedInEmailContextState] = useState<
        Partial<EmbedInEmailContextState>
    >({});

    const [analyticsContextState, setAnalyticsContextState] =
        useState<AnalyticsContextState>({
            enabledForEnvironment:
                window.location.hostname.endsWith("vimeo.com"),
        });

    useEffect(() => {
        getUser()
            .then((user) => {
                const userId = getUserIdFromUri(user.uri);
                configureAnalytics(userId);
            })
            .catch(() => {
                // Intentionally ignore.
            });
    }, []);

    return (
        <AnalyticsContext.Provider
            value={[analyticsContextState, setAnalyticsContextState]}
        >
            <EmbedInEmailContext.Provider
                value={[embedInEmailContextState, setEmbedInEmailContextState]}
            >
                <Outlet />
            </EmbedInEmailContext.Provider>
        </AnalyticsContext.Provider>
    );
}

export default App;
